module.exports = "/_next/static/images/speech_bubble-b9e9da348f0df9e6cda875f9cbe162e5.svg";